import { Component, ViewEncapsulation } from '@angular/core';

/**
 * The shadow dom wrapper encapsulates its inner dom partial into its own
 * shadow dom.
 *
 * It should/must be used to wrap external components, to encapsulate their
 * styles and avoid conflicts with our styles. Main background for this approach
 * are workbench version conflicts and late initializations of workbench css
 * resets from external components, which produce overrides that would otherwise
 * not be avoidable.
 */
// TODO: Fix with MBCC-2652
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'cc-shadow-dom-wrapper',
  templateUrl: './shadow-dom-wrapper.component.html',
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true
})
export class ShadowDomWrapperComponent {}
